'use client'

import React, { InputHTMLAttributes, ReactNode, Ref } from 'react'
import { useInputWrapper } from '../../../hooks/useInputWrapper'
import { ChangeHandler } from 'react-hook-form'
import { Button, ButtonVariants, Spinner } from '../../atoms'
import { EMOJIS } from '../../../../../MyStichtingOpenHelpers/src/static'

export interface FormInputProps
    extends Omit<React.DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'onChange'> {
    disabled?: boolean
    form?: string
    readOnly?: boolean
    loading?: boolean
    error?: boolean
    id?: string
    name?: string
    placeholder?: string
    type?: string
    prefix?: string
    suffix?: ReactNode
    onChange?: (value: string) => void
    onBlur?: ChangeHandler
    onClickSuffix?: () => void
    value?: string
    autoFocus?: boolean
    inputRef?: Ref<HTMLInputElement>
}

export const FormInput = ({
    disabled,
    error,
    prefix,
    suffix,
    form,
    onChange,
    onBlur,
    onClickSuffix,
    readOnly = false,
    type = 'text',
    value,
    autoFocus = false,
    loading = false,
    inputRef,
    ...rest
}: FormInputProps) => {
    const { onFocusHandler, onBlurHandler, classes } = useInputWrapper(false, disabled, error)

    return (
        <div className={`flex items-center border w-full ${classes} ${rest.className || ''}`} data-cy="input-text">
            {prefix && <span className="pl-3 text-shade-600">{prefix}</span>}

            <input
                {...rest}
                disabled={disabled}
                readOnly={readOnly}
                autoCapitalize="off"
                autoComplete="off"
                autoCorrect="off"
                form={form}
                className="w-full px-3 py-2 density-lg:py-3 flex-1 outline-0 bg-transparent placeholder:italic"
                onFocus={onFocusHandler}
                onBlur={(event) => {
                    onBlur && onBlur(event)
                    onBlurHandler()
                }}
                onChange={(event) => onChange && onChange(event.target.value?.replace(EMOJIS, ''))}
                value={value}
                type={type}
                autoFocus={autoFocus}
                aria-invalid={error}
                ref={inputRef}
            />
            {suffix && !onClickSuffix && <span className="pr-3 text-shade-600">{suffix}</span>}

            {suffix && onClickSuffix && (
                <Button variant={ButtonVariants.QUIET} onClick={onClickSuffix}>
                    {suffix}
                </Button>
            )}
            {loading && <Spinner className="mr-2" />}
        </div>
    )
}
